// ** Type Imports
import type { ThemeOptions } from '@mui/material/styles';
import type { OwnerStateThemeType } from '.';
import type { Skin } from '../../types';

const Dialog = (skin: Skin): Partial<NonNullable<ThemeOptions['components']>> => {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }: OwnerStateThemeType) => ({
          backgroundColor: theme.palette.background.menu,
          ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` }),
          // Match MUI responsive full-screen (`fullScreen` + breakpoints.down('sm')).
          [theme.breakpoints.down('sm')]: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%',
            borderRadius: 0,
          },
          '& > .MuiList-root': {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
          },
        }),
        backdrop: {
          backdropFilter: 'blur(4px)',
        },
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        variant: 'h3',
      },
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          padding: theme.spacing(5),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          // Offset title content for notch / Dynamic Island when dialogs go full-screen.
          [theme.breakpoints.down('sm')]: {
            marginTop: `env(safe-area-inset-top)`,
          },
        }),
      },
    },
    MuiDialogContent: {
      defaultProps: {
        classes: { root: 'scroll-box-fade' },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          padding: theme.spacing(5),
          // Offset actions for home indicator when dialogs go full-screen.
          [theme.breakpoints.down('sm')]: {
            marginBottom: `env(safe-area-inset-bottom)`,
          },
          '&.dialog-actions-dense': {
            padding: theme.spacing(2.5),
            paddingTop: 0,
          },
        }),
      },
    },
  };
};

export default Dialog;
